import { useState } from 'react';
import { clearJobPayment } from '../api/jobPayments';
import type { JobPayment } from '../types/jobPayment';

/**
 * Hook for marking a pending payment as cleared
 */
export function useClearPayment() {
  const [isClearing, setIsClearing] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const clear = async (jobId: number, paymentId: number): Promise<JobPayment | null> => {
    setIsClearing(true);
    setError(null);
    try {
      const payment = await clearJobPayment(jobId, paymentId);
      return payment;
    } catch (err) {
      const error = err as { response?: { data?: { message?: string } } };
      setError(error.response?.data?.message || 'Failed to clear payment');
      return null;
    } finally {
      setIsClearing(false);
    }
  };

  return {
    clear,
    isClearing,
    error,
  };
}
